// containers/EstimatesAdmin/parts/WorksSection.jsx
import React from 'react';
import { WORK_CATALOG } from './catalogs';

export default function WorksSection({
    data,
    addWorkTop,
    clearWorks,
    setWorks,
    delWork,
    WorksTable,
}) {
    return (
        <div className="card">
            <div className="section-title"><i></i>Работы — объёмы и расценки</div>
            <div className="actions" style={{ justifyContent: 'space-between', marginTop: 0 }}>
                <div className="row cols-3">
                    <div>
                        <label>Каталог работ</label>
                        <select id="selWorkCatalog">
                            {WORK_CATALOG
                                .filter((x) => !(data.works || []).some((w) => w.key === x.key))
                                .sort((a, b) => a.name.localeCompare(b.name, 'ru'))
                                .map((it) => (
                                    <option key={it.key} value={it.key}>{it.name}</option>
                                ))}
                        </select>
                    </div>
                    <div className="actions">
                        <button
                            className="ghost"
                            onClick={() => {
                                const key = document.getElementById('selWorkCatalog')?.value;
                                addWorkTop(key);
                            }}
                        >
                            Добавить из списка
                        </button>
                        <button className="ghost" onClick={() => addWorkTop(null)}>+ Своя работа</button>
                    </div>
                </div>
                <button className="danger" onClick={clearWorks}>Очистить работы</button>
            </div>

            <WorksTable works={data.works || []} meta={data.meta} onChange={setWorks} onDel={delWork} />
        </div>
    );
}
